export default __webpack_public_path__ + "static/media/avatar2.a8d25874.jpg";